module.exports = __webpack_public_path__ + "img/14.762c8096.jpg";